import React from 'react';
import ClearAllIcon from '../../../assets/icons/clear-all.svg';

import './TableFilterBubbles.scss';

export default function TableFilterBubbles({
  allFilters,
  clearSingleFilterValue,
  addClearAll = true,
  clearAllFilters = null,
  mapping = null,
  render = null,
}) {
  if (!allFilters?.length) return null;

  const displayData = (key, data) => {
    if (!mapping) return data;
    if (mapping[key]) {
      return mapping[key][data] || data;
    }
    return data;
  };

  const renderData = (key, data) => {
    if (!render) return displayData(key, data);
    if (render[key]) {
      return render[key](data);
    }
    return displayData(key, data);
  };

  return (
    <div className="d-flex flex-wrap gap-2">
      {allFilters.map(filter =>
        filter.values.map(value => (
          <div key={`${filter.key}-${value}`} className="filter-bubble px-2">
            <span className="filter-bubble-text">
              {renderData(filter?.key, value)}
            </span>
            <span
              className="filter-bubble-close"
              onClick={() => clearSingleFilterValue(filter.key, value)}
            >
              &times;
            </span>
          </div>
        )),
      )}
      {addClearAll && (
        <div
          className="clear-all-btn px-2"
          onClick={() => {
            if (clearAllFilters) {
              clearAllFilters();
            }
          }}
        >
          <span className="clear-all-btn-text">Reset All</span>
          <img src={ClearAllIcon} alt="Clear All" />
        </div>
      )}
    </div>
  );
}
